import { BackgroundMaterial } from "@babylonjs/core/Materials/Background/backgroundMaterial";
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { CreatePlane } from "@babylonjs/core/Meshes/Builders/planeBuilder";
import { PI_DIV2 } from "../../utils/math";
import { NodeUserData } from "../mdl/NodeUserData";
/* eslint-disable-next-line @typescript-eslint/no-namespace */
export var ShadowGenerator;
(function (ShadowGenerator) {
    const NODEDATA_DISABLESHADOW = "core:disableShadow";
    function disableMeshShadow(pMesh, pDisable = true) {
        NodeUserData.SetData(pMesh, NODEDATA_DISABLESHADOW, pDisable);
    }
    ShadowGenerator.disableMeshShadow = disableMeshShadow;
    function isMeshShadowDisabled(pMesh) {
        return (NodeUserData.GetData(pMesh, NODEDATA_DISABLESHADOW) === true);
    }
    ShadowGenerator.isMeshShadowDisabled = isMeshShadowDisabled;
})(ShadowGenerator || (ShadowGenerator = {}));
/**
 * Creates a floor which only shows shadows. Should be used in combination with shadow mapping.
 */
export function createShadowOnlyFloor(pScene, pOptions) {
    const tOptions = {
        size: 20,
        shadowAlpha: 0.1
    };
    Object.assign(tOptions, pOptions);
    const tMat = new BackgroundMaterial("shadowOnlyFloorMaterial", pScene);
    tMat.shadowOnly = true;
    tMat.primaryColor = new Color3(0, 0, 0);
    tMat.alpha = tOptions.shadowAlpha;
    const tPlane = CreatePlane("shadowOnlyFloor", { width: tOptions.size, height: tOptions.size }, pScene);
    tPlane.rotation.x = PI_DIV2;
    tPlane.isPickable = false;
    tPlane.receiveShadows = true;
    tPlane.material = tMat;
    tPlane.freezeWorldMatrix();
    return (tPlane);
}
